import React, { useEffect } from "react";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { useCase } from "../../../provider/CaseProvider";
import { useDrawer } from "../../../provider/DrawerProvider";
import { userHasOneOfTheseRoles } from "../../../services/backofficeUserService";
import { Roles } from "../../../types/BackofficeUser";
import { useCaseRelatedDrawerConfig } from "../../../hooks/useCaseRelatedDrawerConfig";
import { useOptionalAiChat } from "../../../provider/AiChatProvider";
import DrawerAiEditLock from "../../GlobalDrawer/DrawerAiEditLock";
import { createPortal } from "react-dom";

type CaseRelatedDrawerPortalsProps = {
  refreshActivities: Function;
};

export default function CaseRelatedDrawerPortals({ refreshActivities }: CaseRelatedDrawerPortalsProps) {
  const currentUser = useCurrentUser();
  const { product } = useCase();
  const { drawerContentNode, setDrawerTitle, drawerState } = useDrawer();
  const aiChat = useOptionalAiChat();

  //step-edit drawers get locked while an edit prompt is running: the AI answer will remount the form
  //with the fresh payload, so user input is blocked instead of silently overwritten (fully derived state)
  const isStepEditDrawer = aiChat !== null && aiChat.activeEditStepId !== null;
  const isAiEditPending = isStepEditDrawer && aiChat.isLoading;

  const getDefaultAssignedUser = () => {
    if (userHasOneOfTheseRoles(currentUser, [Roles.lawyer, Roles.accountmanager])) {
      return currentUser["@id"];
    }
    return product?.backofficeCase.accountManager?.["@id"] || "";
  };

  const activeDrawerConfig = useCaseRelatedDrawerConfig({
    product,
    currentUser,
    refreshActivities: refreshActivities,
    defaultAssignedUser: getDefaultAssignedUser(),
  });

  useEffect(() => {
    setDrawerTitle(activeDrawerConfig?.title || "");
  }, [drawerState?.type]);

  if (!activeDrawerConfig) {
    return null;
  }

  return (
    <>
      {drawerContentNode &&
        createPortal(
          isStepEditDrawer ? (
            <DrawerAiEditLock locked={isAiEditPending} label={`${aiChat.activeAgent} arbeitet…`}>
              {activeDrawerConfig?.content}
            </DrawerAiEditLock>
          ) : (
            activeDrawerConfig?.content
          ),
          drawerContentNode,
        )}
      {/*actions are missing here since they are portaled from within the content so that it can control the actions*/}
    </>
  );
}
